// The one way the flow tells the family a card said no — on the payment
// step when a card fails verification, on the finalize step when the
// charge itself declines. The sentence is the server's (keyed off the
// decline code; never the processor's words), and the actions are the
// flow's own secondary buttons, so the notice reads as part of the screen
// rather than an alert dropped onto it.

import { ButtonSpinner } from "components/Button";

import { OUTLINE_BUTTON_CLASS } from "components/FlowButtons";

export interface DeclineAction {
  label: string;
  onClick: () => void;
  /** Shows the spinner and disables the pair — a retry in flight. */
  busy?: boolean;
}

export default function DeclineNotice({
  message,
  primary,
  secondary,
}: {
  message: string;
  /** The retry, when the decline is worth retrying; omitted otherwise. */
  primary?: DeclineAction;
  /** The way out — a different card. */
  secondary: DeclineAction;
}) {
  const busy = Boolean(primary?.busy || secondary.busy);
  return (
    <div
      role="alert"
      className="mt-4 rounded-xl border border-red-200 bg-red-50 px-5 py-4"
    >
      <p className="text-base font-medium text-red-800">{message}</p>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        {primary && (
          <button
            type="button"
            className={OUTLINE_BUTTON_CLASS}
            disabled={busy}
            aria-busy={primary.busy || undefined}
            onClick={primary.onClick}
          >
            {primary.busy && <ButtonSpinner />}
            {primary.label}
          </button>
        )}
        <button
          type="button"
          className={OUTLINE_BUTTON_CLASS}
          disabled={busy}
          aria-busy={secondary.busy || undefined}
          onClick={secondary.onClick}
        >
          {secondary.busy && <ButtonSpinner />}
          {secondary.label}
        </button>
      </div>
    </div>
  );
}
